import { render } from "./fixedList.vue?vue&type=template&id=0d86ae88&scoped=true&ts=true"
import script from "./fixedList.vue?vue&type=script&lang=ts"
export * from "./fixedList.vue?vue&type=script&lang=ts"

import "./fixedList.vue?vue&type=style&index=0&id=0d86ae88&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d86ae88"]])

export default __exports__